export const mapProviderCategories = {
    1: [1,2,7],
    2: [3,4,5],
    3: null,
    4: null,
    5: [6]
}